import { Avatar, Button, createStyles, LinearProgress, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import { DashboardHeader } from "pages/admin/dashboard/components/general";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: 5, },
    '&::-webkit-scrollbar-thumb': { background: '#999999' }
  },
  chart: {
    width: '100%',
    height: '100%',
  },
  tableHead2: {
    color: '#8898AA',
    textAlign: 'center',
    padding: 0
  },
  itemRow: {
    fontSize: '12px !important',
    padding: '5px !important'
  },
  center: {
    textAlign: 'center'
  },
  rounded: {
    width: "22px", height: "21px", paddingTop: "1px", backgroundColor: '#756BF8', cursor: 'pointer'
  },
  btnView: {
    color: "white", fontSize: "10px", backgroundColor: "#EE9B54", padding: "1px 5px"
  },
  progressBar: {

  },
  numProgress: {
    textAlign: "right", color: "slategray", fontSize: "10px"
  }
}));


const ProgressBar = withStyles((theme) =>
  createStyles({
    colorPrimary: {

      backgroundColor: '#E8E7EC',
    },
    bar: {
      backgroundColor: '#6DD570',
    },
  }),
)(LinearProgress);

const ProgressBarRed = withStyles((theme) =>
  createStyles({
    colorPrimary: {

      backgroundColor: '#E8E7EC',
    },
    bar: {
      backgroundColor: '#EF5B58',
    },
  }),
)(LinearProgress);

const StyledTableCell = withStyles((theme) => ({
  head: {
    // backgroundColor: theme.palette.common.black,
    color: '#707070',
    fontSize: 12
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      // backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);


const data = [
  {
    date: '2021-01-01 14:00',
    applicant: 'ธีรวัจน์ บุรวัตร์',
    type: 'Smart S',
    progress: 100,
    status: 'Approved',
    step: '8/8'
  },
  {
    date: '2021-01-10 15:00',
    applicant: 'ทศพร สิริรักษ์',
    docNo: 'T00002',
    type: 'Smart E',
    progress: 60,
    status: 'Rejected',
    step: '5/8'
  },
  {
    date: '2021-01-01 14:00',
    applicant: 'เกษม วงศ์',
    type: 'Smart I',
    progress: 15,
    status: 'Processing',
    step: '1/8'
  },
  {
    date: '2021-01-01 14:00',
    applicant: 'บุญมี สุกพร่ำ',
    type: 'Smart S',
    progress: 20,
    status: 'Processing',
    step: '2/8'
  },
  {
    date: '2021-01-01 14:00',
    applicant: 'สามารถ อลงกรณ์',
    type: 'Smart I',
    progress: 100,
    status: 'Approved',
    step: '8/8'
  },
]

function CheckStatus() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="Check Status" />
      </div>
      <div className={classes.wrapChart}>

        <div style={{ marginTop: 5 }}>
          <div className={clsx(classes.warpData, classes.wrapTable)}>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="customized table">
                <TableHead >
                  <TableRow>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 130 }}>
                      Date
                    </StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 155 }}>Applicant</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 90 }}>Doc No.</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 60 }}>Type</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 100 }}>Progress</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 100 }}>Status</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 50 }}>Contact</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 100, paddingRight: 0 }}>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>

                  {
                    data.map((r, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row" className={clsx(classes.itemRow, classes.center)}>
                          {r.date}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {r.applicant}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          T000{index + 1}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {r.type}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>

                          <div className={clsx(classes.numProgress)}>
                            {r.step}
                          </div>
                          {
                            (index !== 1 && index !== 2 && index !== 3) &&
                            <ProgressBar
                              className="progressBar"
                              variant="determinate" value={r.progress} />
                          }
                          {
                            (index === 1 || index === 2 || index === 3) &&
                            <ProgressBarRed
                              className="progressBar"
                              variant="determinate" value={r.progress} />
                          }
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {r.status}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}
                        // style={{ display: "flex", justifyContent: "center" }}
                        >
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <Avatar variant="rounded" className={classes.rounded}>
                              <PermContactCalendarIcon />
                            </Avatar>
                          </div>


                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          <Button
                            variant="contained"
                            size="small"
                            className={classes.btnView}
                          >
                            View
                          </Button>
                        </StyledTableCell>


                      </StyledTableRow>
                    ))
                  }



                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

      </div>
    </>
  )
}


export default CheckStatus;